export const LIST_PROJECT_INVOICE_DOC_REQUEST = 'LIST_PROJECT_INVOICE_DOC_REQUEST'
export const LIST_PROJECT_INVOICE_DOC_SUCCESS = 'LIST_PROJECT_INVOICE_DOC_SUCCESS'
export const LIST_PROJECT_INVOICE_DOC_FAIL = 'LIST_PROJECT_INVOICE_DOC_FAIL'

export const DETAIL_PROJECT_INVOICE_DOC_REQUEST = 'DETAIL_PROJECT_INVOICE_DOC_REQUEST'
export const DETAIL_PROJECT_INVOICE_DOC_SUCCESS = 'DETAIL_PROJECT_INVOICE_DOC_SUCCESS'
export const DETAIL_PROJECT_INVOICE_DOC_FAIL = 'DETAIL_PROJECT_INVOICE_DOC_FAIL'

export const CREATE_PROJECT_INVOICE_DOC_REQUEST = 'CREATE_PROJECT_INVOICE_DOC_REQUEST'
export const CREATE_PROJECT_INVOICE_DOC_SUCCESS = 'CREATE_PROJECT_INVOICE_DOC_SUCCESS'
export const CREATE_PROJECT_INVOICE_DOC_FAIL = 'CREATE_PROJECT_INVOICE_DOC_FAIL'

export const UPDATE_PROJECT_INVOICE_DOC_REQUEST = 'UPDATE_PROJECT_INVOICE_DOC_REQUEST'
export const UPDATE_PROJECT_INVOICE_DOC_SUCCESS = 'UPDATE_PROJECT_INVOICE_DOC_SUCCESS'
export const UPDATE_PROJECT_INVOICE_DOC_FAIL = 'UPDATE_PROJECT_INVOICE_DOC_FAIL'

export const DELETE_PROJECT_INVOICE_DOC_REQUEST = 'DELETE_PROJECT_INVOICE_DOC_REQUEST'
export const DELETE_PROJECT_INVOICE_DOC_SUCCESS = 'DELETE_PROJECT_INVOICE_DOC_SUCCESS'
export const DELETE_PROJECT_INVOICE_DOC_FAIL = 'DELETE_PROJECT_INVOICE_DOC_FAIL'
